import { TravelXFeatureFlags } from 'src/app/shared/models/enums/team-feature-flags/travelx-feature-flags.enum';
import { WayfarersFlags } from 'src/app/shared/models/enums/team-feature-flags/wayfarers-feature-flags.enum';
import { AccountManagementFeatureFlags } from './team-feature-flags/account-management-feature-flags.enum';
import { AccountOperationsFeatureFlags } from './team-feature-flags/account-operations-feature-flags.enum';
import { AlgoFeatureFlags } from './team-feature-flags/algo-feature-flags.enum';
import { AyaWannaConnectFeatureFlags } from './team-feature-flags/aya-wanna-connect-feature-flags.enum';
import { BabaYagaFeatureFlags } from './team-feature-flags/baba-yaga-feature-flags.enum';
import { CodeBustersFeatureFlags } from './team-feature-flags/code-busters-feature-flags.enum';
import { CNXFeatureFlags } from './team-feature-flags/connexus-feature-flags.enum';
import { EHFeatureFlags } from './team-feature-flags/eh-feature-flags.enum';
import { HWFeatureFlags } from './team-feature-flags/hw-feature-flags.enum';
import { ItsOverNineThousandFeatureFlags } from './team-feature-flags/io9k-feature.flags.enum';
import { LocumsFlags } from './team-feature-flags/locums-feature-flags.enum';
import { MdrFeatureFlags } from './team-feature-flags/mdr-feature-flags.enum';
import { MicDropFeatureFlags } from './team-feature-flags/mic-drop-feature-flags.enum';
import { PathfindersFlags } from './team-feature-flags/pathfinders-feature-flags.enum';
import { PayrollTimecardFeatureFlags } from './team-feature-flags/payroll-timecard-feature-flags.enum';
import { ProgramManagementFeatureFlags } from './team-feature-flags/program-management-feature-flags';
import { StaftPunkFeatureFlags } from './team-feature-flags/staft-punk-feature-flags.enum';
import { StarBucksFeatureFlags } from './team-feature-flags/star-bucks-feature-flags.enum';
import { SupersonicFeatureFlags } from './team-feature-flags/supersonic-feature-flags.enum';
import { SyncOrSwimFeatureFlags } from './team-feature-flags/sync-or-swim-feature-flags.enum';
import { TPFeatureFlags } from './team-feature-flags/tp-feature-flags.enum';
import { TravelRecruitingFlags } from './team-feature-flags/travel-recruiting-flags.enum';
import { TestFeatureFlags } from 'src/app/shared/models/enums/test-feature-flags/test-feature-flags.enum';
import { PerDizzleFeatureFlags } from './team-feature-flags/per-dizzle-feature-flags.enum';
import { HotFeatureFlags } from './team-feature-flags/hot-feature-flags.enum';
import { ESPressoFeatureFlags } from './team-feature-flags/espresso-feature-flags.enum';
import { ModelCitizensFeatureFlags } from 'src/app/shared/models/enums/team-feature-flags/model-citizens-feature-flags.enum';
import { AvengersFeatureFlags } from './team-feature-flags/avengers-feature-flags.enum';

export enum FeatureFlags {
    // **** WFD Flags ****
    WFD_4047_Unhidden_Columns_Become_Hidden_When_Sorting = 'WFD-4047-Unhidden-Columns-Become-Hidden-When-Sorting',
    WFD_4460_Show_Legacy_WFD_Booked_Candidate = 'wfd-4460-show-legacy-wfd-booked-candidate',
    WFD_5270_Live_List_Display_Region_Name = 'WFD_5270_Live_List_Display_Region_Name',
    WFD_5393_Jobs_Manage_Overbook_Bulk = 'WFD_5393_Jobs_Manage_Overbook_Bulk',
    WFD_5376_Booked_Candidate_Dashboard = 'WFD-5376-booked-candidate-dashboard',
    WFD_5395_Open_Position_Bug_Fix = 'wfd-5395-open-position-bug',
    WFD_5510_New_Grid_Urls = 'wfd-5510-new-grid-urls',
    WFD_5473_Job_Capacity_Metrics = 'WFD-5473-job-capacity-metrics',
    WFD_5383_ADD_WFD_RECRUITER_TO_TEAM_INFO = 'WFD_5383_Add_WFD_RECRUITER',
    WFD_5488_Additional_Detail_Edit_Strikes = 'WFD_5488_Additional_Detail_Edit_Strikes',
    WFD_5433_TR_LIVE_LIST_ADD_WFD_RECRUITER = 'WFD_5433_TR_LIVE_LIST_ADD_WFD_RECRUITER',
    WFD_5491_Deals_Display_Wfd_Recruiter = 'WFD-5491-Deals-Display-Wfd-Recruiter',
    WFD_5487_Display_Strike_Duplication = 'WFD-5487-display-strike-duplication',
    WFD_5583_Link_Locums_Jobs_To_Strike = 'WFD-5583-link-locums-jobs-to-strike',
    WFD_5543_Search_All_Candidates_Wfd_Recruiter = 'WFD-5543-search-all-candidates-wfd-recruiter',
    WFD_5582_Booked_Candidate_EmpTye_Update = 'WFD-5582-Booked-Candidate-EmpTye-Update',
    WFD_5584_Support_Locums_Add_Job_Link_To_Strike = 'WFD_5584_Support_Locums_Add_Job_Link_To_Strike',
    WFD_5586_Overbook_Exclude_Locums_Jobs = 'WFD-5586-overbook-exclude-locums-jobs',
    // **** WFD Flags ****

    // **** SRE Flags ****
    // **** SRE Flags ****

    SendMyAyaClinicianContract = 'SendMyAyaClinicianContract',
    FeatureA = 'FeatureA',
    FeatureB = 'FeatureB',
    ComplianceRequirementCategoriesGrid = 'ComplianceRequirementCategoriesGrid',
    EnableWorkforceSolutionsFacilitiesExport = '20220517_TD_8254_ADD_EXPORT_OPTIONS_TO_WFS_FACILITIES',
    TCBillRateBasedOnEffectiveDate = '20220607_AN-20899_TC_BILL_RATE_BASED_ON_EFFECTIVE_DATE',
    NewSubcontractorMarginCalculator = '20220503_TD-7953_SHOW_NEW_UI',
    EnableShippingRequestPOBox = '20220712_TD-7581_SHIPPING_REQUESTS_PO_BOX',
    RecruitingDashboardUseSignalR = '20220714_AN-20395_REC_DASHBOARD_USE_SIGNALR',
    EnableVendorAdminGridFilterRefreshingAfterRecordUpdate = '20220810_TD-8997_ENABLE_VENDOR_ADMIN_GRID_FILTER_REFRESHING_AFTER_RECORD_UPDATE',
    DevOpsFlag = 'DEVOPS_FLAG',
    MoneyMovementValidations = 'MARGIN_MONEY_MOVEMENT_VALIDATIONS',
    RecruitingDashboardJobAlertUseSignalR = 'REC_DASHBOARD_JOB_ALERTS_SIGNALR',
    NovaCandidateLeadScoreDisplay = 'enable-candidate-engagement-display',
    StartEndDateWfdBookedCandidate = 'AN-38794_START_END_DATE_WFD_BOOKED_CANDIDATE',

    EnableRunIntegrationFromDashboard = 'ENABLE_INTEGRATION_RUN_FROM_DASHBOARD',
    AccessSecureUDLinks = 'ACCESS_SECURE_UD_LINKS',
    AccessSecureUdLinksByFacilities = 'access-secure-ud-links',
    EnableNurseAvailabilityFacilitiesFilter = 'NURSE_AVAILABILITY_FACILITIES_FILTER',
    RemoveCancelledByAgencyOption = 'REMOVE_CANCELLED_AGENCY_OPTION',
    DisableCancelledByAgencyOption = 'DISABLE_CANCELLED_AGENCY_OPTION',
    VmsRentalCarEditTotalDays = 'vms-rental-car-expense-edit-total-days',
    EnhanceNovaTimeGridPerformance = 'nova-timecard-grid-performance-improvements',
    EnableBulkTimecardCreation = 'enable-bulk-timecard-creation'
}

export const FeatureFlag = {
    ...FeatureFlags,
    ...AlgoFeatureFlags,
    ...EHFeatureFlags,
    ...CNXFeatureFlags,
    ...HWFeatureFlags,
    ...TravelRecruitingFlags,
    ...TravelXFeatureFlags,
    ...TPFeatureFlags,
    ...WayfarersFlags,
    ...MdrFeatureFlags,
    ...MicDropFeatureFlags,
    ...LocumsFlags,
    ...AccountManagementFeatureFlags,
    ...BabaYagaFeatureFlags,
    ...StarBucksFeatureFlags,
    ...SupersonicFeatureFlags,
    ...AccountOperationsFeatureFlags,
    ...PathfindersFlags,
    ...PayrollTimecardFeatureFlags,
    ...ItsOverNineThousandFeatureFlags,
    ...AyaWannaConnectFeatureFlags,
    ...CodeBustersFeatureFlags,
    ...ProgramManagementFeatureFlags,
    ...AyaWannaConnectFeatureFlags,
    ...SyncOrSwimFeatureFlags,
    //...SvtFeatureFlags,
    ...StaftPunkFeatureFlags,
    ...TestFeatureFlags,
    ...PerDizzleFeatureFlags,
    ...HotFeatureFlags,
    ...ESPressoFeatureFlags,
    ...AvengersFeatureFlags,
    ...ModelCitizensFeatureFlags
};

export type FeatureFlag =
    | FeatureFlags
    | AlgoFeatureFlags
    | EHFeatureFlags
    | CNXFeatureFlags
    | HWFeatureFlags
    | TravelRecruitingFlags
    | TravelXFeatureFlags
    | TPFeatureFlags
    | WayfarersFlags
    | MdrFeatureFlags
    | MicDropFeatureFlags
    | LocumsFlags
    | AccountManagementFeatureFlags
    | BabaYagaFeatureFlags
    | StarBucksFeatureFlags
    | SupersonicFeatureFlags
    | AccountOperationsFeatureFlags
    | PathfindersFlags
    | PayrollTimecardFeatureFlags
    | ItsOverNineThousandFeatureFlags
    | AyaWannaConnectFeatureFlags
    | CodeBustersFeatureFlags
    | ProgramManagementFeatureFlags
    | SyncOrSwimFeatureFlags
    //| SvtFeatureFlags
    | StaftPunkFeatureFlags
    | TestFeatureFlags
    | PerDizzleFeatureFlags
    | HotFeatureFlags
    | ESPressoFeatureFlags
    | AvengersFeatureFlags
    | ModelCitizensFeatureFlags;
